
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({

    totalFacturas: 0,
    facturaActiva: null,




    setFacturaActiva: (factura) => 
        set({ facturaActiva: factura }),
    
});





export const useFacturasStore = create()(
    devtools(
        storeApi
    )
)
